// Defines filters display order and labels in UI

const filtersDisplayConfig = [
];

export default filtersDisplayConfig;